import type * as ecModels from '../../../models'

/**
 * {@link https://ngrx.io/docs State} of this plugin
 */
export interface State<
  TTypeParams extends ecModels.TypeParams = ecModels.TypeParams,
> {
  /**
   * Indicates which {@link ecModels.Target} are currently being edited
   */
  editedTargets: Set<ecModels.Target>
}
export namespace State {
  export const INITIAL: State = {
    editedTargets: new Set(),
  }
}
